<script setup lang="ts">
import { TheSidebar } from '@/core/components';
import type { SidebarMenu } from '@/types/SidebarMenu';

useHead({
  title: 'Components Showcase',
});

definePageMeta({
  auth: false,
});

const menus = computed((): SidebarMenu[] => {
  return [
    {
      title: 'Base',
      link: { name: 'showcase' },
      icon: '',
      class: '',
    },
    {
      title: 'Skeleton loaders',
      link: { name: 'showcase-skeleton-loaders' },
      icon: '',
    },
  ];
});
</script>
<template>
  <v-container class="showcase-page">
    <TheSidebar :prepend-menu="menus" class="showcase-page__sidebar" />
    <div class="showcase-page__content">
      <NuxtPage :page-key="(route) => route.fullPath" />
    </div>
  </v-container>
</template>
<style lang="scss" scoped>
.showcase-page {
  max-width: inherit;
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 5fr;
  grid-template-areas: 'sidebar content';

  &__sidebar {
    grid-area: sidebar;
  }

  &__content {
    grid-area: content;
  }
}
</style>
